import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import DashboardPage from '@pages/dashboard/DashboardPage';
import ResourcesRoutes from './ResourcesRoutes';
import CategoriesRoutes from './CategoriesRoutes';
import LocationsRoutes from './LocationsRoutes';
import TagsRoutes from './TagsRoutes';
import BorrowingsRoutes from './BorrowingsRoutes';
import ConsumptionsRoutes from './ConsumptionsRoutes';
import RefillsRoutes from './RefillsRoutes';
import ProfilePage from '@pages/profile/ProfilePage';
import SettingsPage from '@pages/settings/SettingsPage';
import AdminRoutes from './AdminRoutes';
import NotFoundPage from '@pages/error/NotFoundPage';

export const DashboardRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<Navigate to="/resources" replace />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/resources/*" element={<ResourcesRoutes />} />
            <Route path="/categories/*" element={<CategoriesRoutes />} />
            <Route path="/locations/*" element={<LocationsRoutes />} />
            <Route path="/tags/*" element={<TagsRoutes />} />
            <Route path="/borrowings/*" element={<BorrowingsRoutes />} />
            <Route path="/consumptions/*" element={<ConsumptionsRoutes />} />
            <Route path="/refills/*" element={<RefillsRoutes />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="/admin/*" element={<AdminRoutes />} />
            <Route path="*" element={<NotFoundPage />} />
        </Routes>
    );
};

export default DashboardRoutes;